// @owners { team: patients }
import {
  type BACKGROUND_COLORS_VALUES,
  type BaseIconName,
  COLORS,
  type ColorVariant,
} from '@alto/design-library-tokens';

export type Instructions = {
  iconName: BaseIconName;
  text: string;
  type?: ColorVariant;
  backgroundColor?: BACKGROUND_COLORS_VALUES;
};

export const emptyInstruction: Instructions = {
  iconName: 'box',
  text: '',
};

export const pickUpInstruction: Instructions = {
  iconName: 'box',
  text: "You're picking up this package",
  type: 'success',
};

export const getSignatureRequiredInstruction = (): Instructions => ({
  iconName: 'signpaper',
  text: 'Someone needs to be present to sign for this delivery',
  type: 'grey',
  backgroundColor: COLORS.BACKGROUND_COLORS.WARNING_LIGHTEST,
});

export const getPhotoIDRequiredInstruction = (): Instructions => ({
  iconName: 'idcard',
  text: '18+ photo ID & signature required',
  type: 'grey',
  backgroundColor: COLORS.BACKGROUND_COLORS.WARNING_LIGHTEST,
});

export const getPresenceRequiredInstruction = (): Instructions => ({
  iconName: 'handbox',
  text: 'Someone needs to be present to receive this delivery',
  type: 'grey',
  backgroundColor: COLORS.BACKGROUND_COLORS.WARNING_LIGHTEST,
});

export const leavePackageInstruction: Instructions = {
  iconName: 'homelock',
  text: 'No need to be present for delivery',
  type: 'grey',
};
